<template>
    <div class="container-fluid">
        <div class="row"> 
            <FormShipping colClass="col-12" headerTitle="true" titles="true" title="ใบจัดส่งสินค้า"/>
            <div class="col-sm-12 col-md-12 col-xl-6">
              <DomeDelivery />
              <DomeInstall />
            </div>
            <div class="col-sm-12 col-md-12 col-xl-6">
              <Card3 colClass="col-sm-12 col-md-12 col-xl-12" pre="true" preClass="f-m-light mt-1" headerTitle="true" :title="'อุปกรณ์'">
              <ul class="simple-wrapper nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" v-for="(equipment, index) in form.stock" :key="index">
                  <a class="nav-link txt-primary"  :class="{ active: index === 0 }" :id="'tab-' + index" data-bs-toggle="tab" :href="'#tab-content-' + index" role="tab" :aria-controls="'tab-content-' + index" :aria-selected="index === 0">({{index+1}}) {{equipment.group_product}}</a>
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade" :class="{ 'show active': index === 0 }" :id="'tab-content-' + index" role="tabpanel" :aria-labelledby="'tab-' + index" v-for="(equipment, index) in form.stock" :key="index">
                  <FormProductShipping colClass="col-12" v-model="form.stock[index]"/>
                </div>
              </div>
              <div class="input-group flex-nowrap col-12 mt-3" style="margin-bottom: 16px;">
                <span class="input-group-text">พนักงานจัดส่ง</span>
                <input class="form-control" type="text" v-model="user" disabled>
              </div>
            </Card3>
            <FormAdditionalProduct v-model="additional_product"/>
            </div>
            <!-- <FormProductShipping colClass="col-12" headerTitle="true" titles="true" title="อุปกรณ์" v-model="form"/> -->
        </div>
        <button class="btn btn-danger pull-right mb-4" type="button" @click="deleteForm()">ลบ</button>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { useRoute , useRouter} from 'vue-router';
import { directus } from "@/services/directus";
import { updateItem , deleteItem , readItems} from "@directus/sdk";
import Swal from 'sweetalert2'

const FormShipping = defineAsyncComponent(() => import("@/components/theme/receipt-product/FormShipping.vue"))
const FormProductShipping = defineAsyncComponent(() => import("@/components/theme/receipt-product/FormProductShipping.vue"))
const FormAdditionalProduct = defineAsyncComponent(() => import("@/components/theme/receipt-product/FormAdditionalProduct.vue"))
const DomeDelivery = defineAsyncComponent(() => import("@/components/theme/receipt-product/DomeDelivery.vue"))
const DomeInstall = defineAsyncComponent(() => import("@/components/theme/receipt-product/DomeInstall.vue"))
const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))

const form = ref({});
const route = useRoute()
const router = useRouter()
const user = ref(localStorage.getItem('user_full_name'))
const additional_product = ref({})

const fetchData = async () => {
  try {
    const response = await directus.request(
      readItems("delivery_sheet", {
        filter: {
          id: { _eq: route.params.id },
        },
        fields: ["*.*.*"],
        limit: -1
      })
    );
    if (response.length > 0) {
        const data = response[0];
        additional_product.value = data.additional_product || [];
        form.value = {
          stock: data.packing_sheet[0].stock || [],
          packing_sheet: data.packing_sheet[0] || [],
          document_delivery_number: data.document_delivery_number || '',
        };
    }
  } catch (error) {
    console.error("Error fetching activities:", error);
  }
};

fetchData()

async function deleteForm() {
  const confirmDeleteResult = await questionsAlert();
  
  if (!confirmDeleteResult.isConfirmed) return;

  try {
    const timestamp = new Date().toISOString().split('.')[0];
    const user = localStorage.getItem('user_full_name');

    const docNumber = form.value.document_delivery_number;
    
    const removeFromDocumentDeliveryTransaction = {
      transaction_type: "update",
      timestamp: timestamp,
      remarks: 'นำออกจากใบจัดสินค้าเลขที่ ' + docNumber,
      user: user,
    };

    for (let index = 0; index < form.value.stock.length; index++) {
      if (!Array.isArray(form.value.stock[index].history)) {
        form.value.stock[index].history = [];
      }
      form.value.stock[index].history.push(removeFromDocumentDeliveryTransaction);
      await directus.request(
        updateItem('stock', form.value.stock[index].id, {
          status: 'พร้อมใช้งาน',
          history: form.value.stock[index].history,
        })
      )
    }
    await directus.request(
      deleteItem("delivery_sheet", route.params.id)
    );
    await directus.request(
      updateItem('packing_sheet', form.value.packing_sheet.id, {
        status: 'รอเช็คก่อนส่ง',
      })
    )
    router.push({ name: 'listShipping' });
  } catch (error) {
    alert("Failed to delete item: " + error.message);
  }
}

function questionsAlert() {
    return Swal.fire({
        icon: "warning",
        text: 'ยืนยันการลบข้อมูล?',
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        cancelButtonColor: '#efefef',
        confirmButtonText: "ใช่, ลบเลย!",
        confirmButtonColor: 'var(--theme-default)',
    });
}
</script>